import axiosBasicInstance from '../axiosConfig';

export const getInfoByTaxcode = async (taxCode) => {
   try {
      const response = await axiosBasicInstance.get(`/management/getInfoFromTaxCode/${taxCode}`);
      return response;
   } catch (error) {
      throw error;
   }
};
